import { Wand2 } from 'lucide-react';

/** Schmale Leiste am unteren Rand, nur während eines externen Zugs: Ziel für den Rückfall-Weg. */
export default function ExternalDropBar({ highlighted, dropProps }) {
  return (
    <div className={`external-drop-bar${highlighted ? ' is-target' : ''}`} {...dropProps} data-testid="external-drop-bar">
      <Wand2 size={16} aria-hidden /> Automatisch
    </div>
  );
}
